import { Droplets } from "lucide-react";
import { Link } from "react-router-dom";
import { cities } from "@/data/cities";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-card border-t border-border py-12" role="contentinfo">
      <div className="container container-narrow text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="p-2 rounded-lg bg-primary/10">
            <Droplets className="w-5 h-5 text-primary" />
          </div>
          <span className="font-display font-bold text-xl text-foreground">
            Plasmaspenden Bonus
          </span>
        </div>

        <nav aria-label="Footer Navigation" className="mb-8">
          <ul className="flex flex-wrap justify-center gap-6 text-sm">
            <li>
              <a
                href="/#wissen"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Wissen
              </a>
            </li>
            <li>
              <a
                href="/#vorteile"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Vorteile
              </a>
            </li>
            <li>
              <a
                href="/#ablauf"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Ablauf
              </a>
            </li>
            <li>
              <a
                href="/#bonus"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Bonus
              </a>
            </li>
            <li>
              <a
                href="/#voraussetzungen"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Voraussetzungen
              </a>
            </li>
            <li>
              <a
                href="/#standorte"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Standorte
              </a>
            </li>
            <li>
              <a
                href="/#faq"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                FAQ
              </a>
            </li>
            <li>
              <a
                href="/#ratgeber"
                className="text-muted-foreground hover:text-primary transition-colors py-2 inline-block"
              >
                Ratgeber
              </a>
            </li>
          </ul>
        </nav>

        {/* City Landing Pages for SEO & Crawlability */}
        <div className="pt-6 mb-8 border-t border-border/60">
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wider mb-4">
            Plasmaspenden Standorte & Zentren in Deutschland
          </p>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
            {cities.map((city) => (
              <Link
                key={city.slug}
                to={`/${city.slug}`}
                className="hover:text-primary transition-colors py-1 inline-block"
                title={`Plasmaspenden in ${city.name}`}
              >
                {city.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="pt-6 border-t border-border flex flex-col justify-center items-center gap-2">
          <p className="text-sm text-muted-foreground">
            Alle Angaben ohne Gewähr.
          </p>
          <div className="flex justify-center items-center gap-2 text-sm text-muted-foreground">
            <Link
              to="/impressum"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Impressum
            </Link>
            <span className="text-muted-foreground">•</span>
            <Link
              to="/werbehinweis"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              Werbehinweis
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
